<bl-modal-content #content
  [title]="title"
  [footerButtonType]="footerButtonType"
>

  <div body>
    <div class="message-container">
      <span class="glyphicon glyphicon-exclamation-sign"></span>
      <div class="message">Yahoo!ログインの有効期限は{{ data?.expirationDate }}です。再ログインしてください。</div>
    </div>
  </div>

  <div footer blFocusControl>
    <share-yahoo-login-button></share-yahoo-login-button>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/yahoo-warn-modal/yahoo-warn-modal.component.html